import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getAll } from 'services/groups.service';
import { STATUSES } from 'redux/statuses';

export const setGroupsIfEmpty = createAsyncThunk(
  'groups/setGroupsIfEmpty',
  async (payload, { getState }) => {
    try {
      const { data } = await getAll();
      return data;
    } catch (error) {
      console.error(error);
    }
  },
  {
    condition(payload, { getState }) {
      const { groups } = getState();
      return groups.status === STATUSES.EMPTY;
    },
  },
);

const initialState = {
  status: STATUSES.EMPTY,
  items: [],
};

const groupsSlice = createSlice({
  name: 'groups',
  initialState,
  reducers: {
    setGroups(state, action) {
      return {
        status: STATUSES.FULFILLED,
        items: action.payload,
      };
    },
    unsetGroups(state, action) {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(setGroupsIfEmpty.pending, (state, action) => {
        state.status = STATUSES.PENDING;
      })
      .addCase(setGroupsIfEmpty.fulfilled, (state, action) => {
        return {
          status: STATUSES.FULFILLED,
          items: action.payload,
        };
      });
  },
});

export const { setGroups, unsetGroups } = groupsSlice.actions;

export default groupsSlice.reducer;
